import { JsFormResponseHandlerObject } from '../jsFormTypes';
import { JRpcResponse } from '../jsonRpc/jsonRpcResponseFactory';
import { isValidEmail } from '../validators';
import { ErrorToolTip, TooltipDirection } from '../../newErrorToolTip';
import { Localization } from '../../../localization/localization';
import { Onelink } from '../onelink/Onelink';
import { GlobalAppConfig } from '../../../types/windowPatching';

export class MobileLpFormHandlers {
    private appConfig: GlobalAppConfig;
    constructor(config: GlobalAppConfig) {
        this.appConfig = config;
    }

    public registerHandlers(): void {
        window.app.redirectToStoreVieOneLink = this.redirectToStoreVieOneLink.bind(this);
    }

    private redirectToStoreVieOneLink(data: JsFormResponseHandlerObject<JRpcResponse<{}>>): void | boolean {
        $('.error', data.form).removeClass('error');

        const $form = data.form;
        const emailInput = $('input[name=email]', $form);
        const email = emailInput.val() as string;

        const toolTipDirection: keyof typeof TooltipDirection = data.caller.data('tooltipdirection');
        const toolTipDirectionSide: TooltipDirection = TooltipDirection[toolTipDirection];
        const emailInputContainer = emailInput.parents('.white_input');

        if (!isValidEmail(email)) {
            const errorToolTip = ErrorToolTip.getTooltipElement();
            emailInputContainer.addClass('error');
            errorToolTip.showTooltipElement(
                emailInput,
                toolTipDirectionSide as TooltipDirection,
                Localization._n('wrong_data')
            );
            return false;
        }

        const onelink = new Onelink(this.appConfig.landings.onelink_url, navigator.userAgent);
        onelink.setDefaultOpts();
        location.href = onelink.generate();
        return false;
    }
}
